import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Subject, filter, map } from 'rxjs';
import { PdfThumbnailViewportService } from '../pdf-thumbnail-viewport/pdf-thumbnail-viewport.service';
import { PdfThumbnailService } from './pdf-thumbnail.service';

@Component({
  selector: 'ss-pdf-thumbnail',
  templateUrl: './pdf-thumbnail.component.html',
  styleUrls: ['./pdf-thumbnail.component.scss'],
  providers: [
    PdfThumbnailService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfThumbnailComponent {

  private readonly _destroy = new Subject<void>();

  readonly pdfPageInfoSubject = this._pdfThumbnailService.pdfPageInfoSubject;
  @Input() get pdfPageInfo() {
    return this.pdfPageInfoSubject.value
  }
  set pdfPageInfo(value) {
    this.pdfPageInfoSubject.next(value)
  }
  readonly imgPathObs = this._pdfThumbnailService.imgPathObs;
  readonly PAGE_SPACING = this._pdfThumbnailService.PAGE_SPACING;

  readonly heightObs = this.pdfPageInfoSubject.pipe(
    filter(Boolean),
    map((pdfPageInfo) => pdfPageInfo.dimensions.height)
  )

  readonly widthObs = this.pdfPageInfoSubject.pipe(
    filter(Boolean),
    map((pdfPageInfo) => pdfPageInfo.dimensions.width)
  )

  readonly styleObs = this.pdfPageInfoSubject.pipe(
    filter(Boolean),
    map((pdfPageInfo) => ({
      height: pdfPageInfo.dimensions.height + 'px',
      width: pdfPageInfo.dimensions.width + 'px'
    }))
  )

  readonly isSelectedObs = this._pdfThumbnailService.isSelectedObs;
  readonly pdfPageVisibleSubject = this._pdfThumbnailService.pdfPageVisibleSubject;

  // @ViewChild('pdfThumbnail')
  // private _canvasRef!: ElementRef<HTMLCanvasElement>

  // @ViewChild('divOverlay')
  // private _divOverlayRef!: ElementRef<HTMLDivElement>

  // @ViewChild('container')
  // private _containerRef!: ElementRef<HTMLDivElement>

  // private _pageIdx!: number;

  // @Input() get pageIdx() {
  //   return this._pageIdx
  // }

  // set pageIdx(value: number) {
  //   this._pageIdx = value;
  //   this._pdfThumbnailService.pageIdxSubject.next(this.pageIdx);
  // }

  // readonly renderingSubject = this._pdfThumbnailService.renderingSubject;

  // readonly canvasHeightObs = this._pdfThumbnailViewportService.canvasHeightObs;
  // readonly virtualElementHeightObs = this._pdfThumbnailViewportService.virtualElementHeightObs;
  // readonly isSelectedObs = this._pdfThumbnailService.isSelectedObs;
  // readonly widthSubject = this._pdfThumbnailService.widthSubject;

  // readonly canvasInferredStylesObs = this._pdfThumbnailService.canvasInferredStylesObs;
  // readonly divContainerStylesObs = this._pdfThumbnailService.divContainerStylesObs;
  constructor(
    private _pdfThumbnailViewportService: PdfThumbnailViewportService,
    private _pdfThumbnailService: PdfThumbnailService
  ) {

  }

  // ngOnInit() {

  // }

  // ngAfterViewInit(): void {

  //   this._pdfThumbnailService.canvasElementSubject.next(this._canvasRef.nativeElement);
  //   this._pdfThumbnailService.divOverlaySubject.next(this._divOverlayRef.nativeElement);


  //   // new Observable<number>((observer) => {
  //   //   const intervalRef = setInterval(() => {
  //   //     observer.next(this._containerRef.nativeElement.clientWidth)
  //   //   },
  //   //     200
  //   //   )

  //   //   this._destory.subscribe(() => {
  //   //     observer.complete()
  //   //     clearInterval(intervalRef)
  //   //   })

  //   // })
  //   //   .pipe(
  //   //     takeUntil(this._destory),
  //   //     distinctUntilChanged()
  //   //   )
  //   //   .subscribe((width) => this.widthSubject.next(width))
  // }

  pageSelected() {

    this._pdfThumbnailViewportService.selectPage(this.pdfPageInfo);
  }

  ngOnDestroy() {
    this._destroy.next()
    this._destroy.complete()
  }

}
